/* eslint-disable @next/next/no-img-element */
import React, { useEffect, useState } from 'react';
import Head from 'next/head';
import Container from '../../atoms/Container';
import Styles from './BlogImage.css';
import { useAmp } from 'next/amp';

function BlogImage({
  src,
  desktopSrc,
  enablePreload,
  altImg,
  width,
  height,
  desktopwidth,
  desktopheight,
  isresized,
  marginbottom,
  ...props
}) {
  const isAmp = useAmp();
  const [mobile, setMobile] = useState(true);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      setMobile(window.innerWidth < 992);
      window.addEventListener('resize', function () {
        setMobile(window.innerWidth < 992);
      });
    }
  }, []);

  return (
    <>
      {enablePreload && (
        <Head>
          {!!desktopSrc ? (
            <>
              <link rel="preload" href={src} as="image" media="(max-width: 991px)" />
              <link rel="preload" href={desktopSrc} as="image" media="(min-width: 992px)" />
            </>
          ) : (
            <link rel="preload" href={src} as="image" />
          )}
        </Head>
      )}

      <article {...props} className={`blog-image ${props.className}`}>
        <Container extraPadding>
          <div
            className={`img-container ${isAmp ? '' : 'ampless'}`}
            style={
              isresized
                ? {
                    height: mobile ? `${height}` : `${desktopheight}`,
                    width: mobile ? `${width}` : `${desktopwidth}`,
                    marginBottom: `${marginbottom}`,
                  }
                : {}
            }
          >
            {isAmp && (
              <amp-img
                className={!!desktopSrc ? 'mobile' : ''}
                layout="fill"
                src={src}
                alt={altImg}
              />
            )}

            {!isAmp && <img className={!!desktopSrc ? 'mobile' : ''} src={src} alt={altImg} />}

            {!!desktopSrc && isAmp && (
              <amp-img className="desktop" layout="fill" src={desktopSrc} alt={altImg} />
            )}

            {!!desktopSrc && !isAmp && <img className="desktop" src={desktopSrc} alt={altImg} />}
          </div>
        </Container>
      </article>
      <style jsx>{Styles}</style>
    </>
  );
}

export default BlogImage;
